module.exports = __webpack_public_path__ + "static/01-3a2fae38c5a44e83eb807f1cb735830f.jpg";